import {postBlockUser} from '../api/postBlockUser';
import {setGetUserById} from './setGetUserById';

const setPostBlockUser = (params) => {
    return async (dispatch, getState) => {
        try {
            await postBlockUser(params);
            dispatch(setGetUserById(params.id));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostBlockUser
}